export const initialState = {
   eventsData: {},
}
